import React, { Component } from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import {
  Button,
  Form,
  Grid,
  Header,
  Input,
  Message,
  Segment
} from 'semantic-ui-react';

import '../css/Login.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import DynamicSatelliteService from '../services/DynamicSatelliteService';

import { setDocumentTitle } from '../utils/setDocumentTitle';

import { register } from '../i18n';

const t = register('NewPassword');

export default @inject(
  'dynamicSatelliteManager', 'userManager')
@observer
class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPasswordInputType: 'password',
      fail: false,
      invalid: false,
      loaded: false,
      newPassword: '',
      newPasswordInputType: 'password',
      password: '',
      passwordChangeId: '',
      success: false,
      tooShort: false
    };
    this.Logo = SatCoreComponent('Logo');
    this.SatCoreLoader = SatCoreComponent('SatCoreLoader');
    this.ShowPasswordButton = SatCoreComponent('ShowPasswordButton');
  }

  async componentDidMount() {
    this.setState({ loaded: false });

    const { dynamicSatelliteManager, location } = this.props;

    const params = location.pathname;
    const passwordChangeId = params.substring(16);
    this.setState({ passwordChangeId });

    if (dynamicSatelliteManager.isDynamicSatellite && !Auth.publisherSatelliteCode) {
      await DynamicSatelliteService.fetchDynamicSatelliteByDomain();
      setTimeout(() => {
        this.setState({ loaded: true });
        setDocumentTitle('changeYourPassword', { translationObjName: 'NewPassword' });
      }, 500);
    } else {
      this.setState({ loaded: true });
      setDocumentTitle('changeYourPassword', { translationObjName: 'NewPassword' });
    }
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    );
  };

  handleChangePassword = async (event) => {
    const { userManager } = this.props;
    const { newPassword, password, passwordChangeId } = this.state;
    event.preventDefault();
    this.setState({ tooShort: false, fail: false, success: false, invalid: false });

    if (newPassword !== password) {
      this.setState({ invalid: true }, () => {
        this.messageRef?.current?.focus?.();
      });
      return;
    }

    if (newPassword.length < 8) {
      this.setState({ tooShort: true }, () => {
        this.messageRef?.current?.focus?.();
      });
      return;
    }

    const success = await userManager.resetPassword(passwordChangeId, password);
    if (success) {
      this.setState({ success: true }, () => {
        this.messageRef?.current?.focus?.();
      });
    } else {
      this.setState({ fail: true }, () => {
        this.messageRef?.current?.focus?.();
      });
    }
  };

  handleGoLogin = () => {
    this.props.history.push('/signin');
  };

  handleShowPasswordPressed = (name, isPasswordInput) => {
    const inputType = isPasswordInput ? 'password' : 'text';
    this.setState({ [name]: inputType });
  };

  render() {
    const { Logo, SatCoreLoader, ShowPasswordButton } = this;
    const { confirmPasswordInputType, fail, invalid, loaded, newPasswordInputType, success, tooShort } = this.state;
    const shouldDisplayAccessibleMessageParent = fail || invalid || success || tooShort;

    return loaded ? (
      <Grid
        className='login-grid new-password'
        textAlign='center'
        verticalAlign='middle'>
        <Grid.Column>
          <Form>
            <Header
              aria-label={t('changeYourPassword')}
              as='h2'
              attached='top'
              block
              className='new-password-form-header'
              tabIndex={0}>
              <Logo />
              <div className='header-text'>
                {t('changeYourPassword')}
              </div>
            </Header>
            <div className='login-divider' />
            <Segment attached className='element-body-login element-body-login-new-password'>
              <Form.Field>
                <label htmlFor='newPassword'>{t('newPassword')}</label>
                <Input
                  icon={(
                    <ShowPasswordButton
                      isPassword={(newPasswordInputType === 'password')}
                      name='newPasswordInputType'
                      onFlip={this.handleShowPasswordPressed} />
                  )}
                  id='newPassword'
                  name='newPassword'
                  onChange={this.handleChange}
                  placeholder={t('newPasswordPlaceholder')}
                  type={newPasswordInputType} />
              </Form.Field>
              <Form.Field>
                <label htmlFor='password'>{t('confirmPassword')}</label>
                <Input
                  icon={(
                    <ShowPasswordButton
                      isPassword={(confirmPasswordInputType === 'password')}
                      name='confirmPasswordInputType'
                      onFlip={this.handleShowPasswordPressed} />
                  )}
                  id='password'
                  name='password'
                  onChange={this.handleChange}
                  placeholder={t('passwordPlaceholder')}
                  type={confirmPasswordInputType} />
              </Form.Field>
              <Form.Field>
                <Button className='change-password' onClick={this.handleChangePassword} primary>
                  {t('updatePassword')}
                </Button>
              </Form.Field>
            </Segment>
          </Form>
          <div
            ref={this.messageRef}
            aria-live='assertive'
            className={classNames('accessible-message-parent', {
              'accessible-negative-message-parent': !success,
              'accessible-positive-message-parent': success
            })}
            style={{
              display: shouldDisplayAccessibleMessageParent ? 'block' : 'none'
            }}
            tabIndex={-1}>
            {(success)
              ? (
                <div role='alert'>
                  <Message positive>
                    <Message.Header>{t('successHeader')}</Message.Header>
                    <p>
                      {t('successMessage')}
                    </p>
                    <Button className='goto-login' color='green' onClick={this.handleGoLogin}>
                      {t('goToLogin')}
                    </Button>
                  </Message>
                </div>
              ) : null}
            {(fail)
              ? (
                <div role='alert'>
                  <Message negative>
                    <Message.Header>{t('errorFailHeader')}</Message.Header>
                    <p>
                      {t('errorFailMessage')}
                    </p>
                  </Message>
                </div>
              ) : null}
            {(invalid)
              ? (
                <div role='alert'>
                  <Message negative>
                    <Message.Header>{t('errorInvalidHeader')}</Message.Header>
                    <p>
                      {t('errorInvalidMessage')}
                    </p>
                  </Message>
                </div>
              ) : null}
            {(tooShort) ? (
              <div role='alert'>
                <Message negative>
                  <Message.Header>{t('errorTooShortHeader')}</Message.Header>
                  <p>
                    {t('errorTooShortMessage')}
                  </p>
                </Message>
              </div>
            ) : null}
          </div>
        </Grid.Column>
      </Grid>
    ) : <SatCoreLoader />;
  }
}

SatCoreRegister('NewPassword', NewPassword);
